import React from 'react'

import { AdoptionComponent } from '../../constants/AdoptionComponent'

import { getDsAdoptionAttribute } from './getDsAdoptionAttribute'

export const useDsAdoptionAttribute = (componentName: AdoptionComponent | string) => {
  return React.useMemo(() => getDsAdoptionAttribute(componentName), [componentName])
}
